import exif from 'exif-js';

const getImageOrientation = (imageFile) =>
  new Promise((resolve) => {
    exif.getData(imageFile, () => {
      resolve(exif.getTag(imageFile, 'Orientation'));
    });
  });

export default getImageOrientation;
